import { render, staticRenderFns } from "./samHelp.vue?vue&type=template&id=1bd4f7df"
import script from "./samHelp.vue?vue&type=script&lang=js"
export * from "./samHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports